import React from 'react';
import axios from 'axios';
import HOC from './HOC';
import { Link } from 'react-router-dom';
import { FaUserCircle, FaChevronRight } from 'react-icons/fa';
import ReactHtmlParser from 'react-html-parser';
import apiUrl from './base_url';

import '../components/cssfile/header.css';
import '../components/cssfile/home.css';
import '../components/cssfile/instruction.css';
import '../components/cssfile/footer.css';
import '../components/cssfile/admin.css';
import '../components/cssfile/card.css';
import '../components/cssfile/ca.css';
import '../components/cssfile/sidebar.css';
import '../components/cssfile/dashboard.css';

class Instruction extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            instruction: [],
            language: '',
            isLoading: true,
            error: ''
        };
    }

    handleLanguageChange = (event) => {
        this.setState({
            language: event.target.value
        });
    };

    handleNext = () => {
        // Reserved for future navigation logic
    };

    componentDidMount() {
        const test_id = localStorage.getItem('test_id');

        axios
            .get(apiUrl + `serverside/instruction.php?test_id=${test_id}`)
            .then(response => {
                this.setState({
                    instruction: response.data,
                    isLoading: false
                });
            })
            .catch(error => {
                console.error(error);

                this.setState({
                    isLoading: false,
                    error: 'Unable to load test instructions.'
                });
            });
    }

    render() {
        const email = localStorage.getItem('email');
        const regid = localStorage.getItem('regid');
        const test_id = localStorage.getItem('test_id');

        const exam_id1 =
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.id;

        /*
         * Preserve existing logic
         */
        localStorage.setItem('exam_id', exam_id1);

        if (!email || !regid) {
            this.props.history.push('/login');
            return null;
        }

        const {
            instruction,
            language,
            isLoading,
            error
        } = this.state;

        return (
            <div id="instruction" className="instruction-page">

                {/* =====================================================
                    FIXED HEADER
                   ===================================================== */}
                <header className="instruction-header">

                    <div className="instruction-header-inner">

                        <div className="instruction-brand">
                            <div className="instruction-brand-mark">
                                E
                            </div>

                            <div className="instruction-brand-text">
                                <strong>ErwaToday</strong>
                                <span>Online Test Platform</span>
                            </div>
                        </div>

                        <div className="instruction-header-right">
                            <div className="instruction-user-mini">
                                <FaUserCircle />

                                <div>
                                    <strong>{email}</strong>
                                    <span>Candidate ID: {regid}</span>
                                </div>
                            </div>
                        </div>

                    </div>

                </header>


                {/* =====================================================
                    MAIN CONTENT
                   ===================================================== */}
                <main className="instruction-main">

                    <div className="instruction-layout">

                        {/* ================= LEFT CONTENT ================= */}
                        <section className="instruction-content">

                            <div className="instruction-content-header">

                                <div>
                                    <span className="instruction-label">
                                        TEST INSTRUCTIONS
                                    </span>

                                    <h1>
                                        Read Instructions Carefully
                                    </h1>

                                    <p>
                                        Please select your preferred language
                                        before starting the test.
                                    </p>
                                </div>

                                <div className="language-control">

                                    <label htmlFor="language">
                                        Default Language
                                    </label>

                                    <select
                                        id="language"
                                        value={language}
                                        onChange={this.handleLanguageChange}
                                    >
                                        <option value="">
                                            Select Language
                                        </option>

                                        <option value="hi">
                                            Hindi
                                        </option>

                                        <option value="en">
                                            English
                                        </option>
                                    </select>

                                </div>

                            </div>


                            {/* ================= LOADING ================= */}
                            {isLoading && (
                                <div className="instruction-loading">
                                    <div className="instruction-spinner"></div>

                                    <p>
                                        Loading instructions...
                                    </p>
                                </div>
                            )}


                            {/* ================= ERROR ================= */}
                            {!isLoading && error && (
                                <div className="instruction-error">
                                    {error}
                                </div>
                            )}


                            {/* ================= INSTRUCTIONS ================= */}
                            {!isLoading &&
                                !error &&
                                instruction.length > 0 &&
                                instruction.map((item) => (

                                    <article
                                        key={item.id}
                                        className="instruction-card"
                                    >

                                        <div className="instruction-card-heading">

                                            <span className="instruction-number">
                                                01
                                            </span>

                                            <div>
                                                <span className="instruction-small-label">
                                                    TEST
                                                </span>

                                                <h2>
                                                    {this.props.location.state.topic_name}
                                                </h2>
                                            </div>

                                        </div>


                                        <div className="instruction-divider"></div>


                                        <div className="instruction-topic">

                                            <h3>
                                                {item.topic_name}
                                            </h3>

                                            <div className="instruction-description">
                                                {ReactHtmlParser(item.des)}
                                            </div>

                                        </div>

                                    </article>

                                ))}


                            {/* ================= EMPTY ================= */}
                            {!isLoading &&
                                !error &&
                                instruction.length === 0 && (

                                    <div className="instruction-empty">

                                        <FaUserCircle />

                                        <h3>
                                            Instructions Not Available
                                        </h3>

                                        <p>
                                            No instructions were found for
                                            this test.
                                        </p>

                                    </div>
                                )}

                        </section>


                        {/* ================= RIGHT PROFILE ================= */}
                        <aside className="instruction-sidebar">

                            <div className="candidate-profile-card">

                                <div className="candidate-profile-top">

                                    <div className="candidate-avatar">
                                        <FaUserCircle />
                                    </div>

                                    <span className="candidate-status">
                                        Ready
                                    </span>

                                </div>


                                <div className="candidate-profile-info">

                                    <span className="profile-label">
                                        CANDIDATE
                                    </span>

                                    <h3>
                                        {email}
                                    </h3>

                                    <p>
                                        Registration ID
                                    </p>

                                    <strong>
                                        {regid}
                                    </strong>

                                </div>


                                <div className="profile-divider"></div>


                                <div className="test-summary">

                                    <div>
                                        <span>Test</span>
                                        <strong>
                                            {test_id}
                                        </strong>
                                    </div>

                                    <div>
                                        <span>Language</span>

                                        <strong>
                                            {language
                                                ? language === 'hi'
                                                    ? 'Hindi'
                                                    : 'English'
                                                : 'Not Selected'}
                                        </strong>
                                    </div>

                                </div>

                            </div>

                        </aside>

                    </div>

                </main>


                {/* =====================================================
                    BOTTOM ACTION
                   ===================================================== */}
                <div className="instruction-action-bar">

                    {!language ? (

                        <div className="instruction-warning">
                            <span>!</span>

                            <div>
                                <strong>
                                    Select a language to continue
                                </strong>

                                <small>
                                    Choose Hindi or English before starting
                                    the test.
                                </small>
                            </div>
                        </div>

                    ) : (

                        <div className="instruction-ready">

                            <div>
                                <strong>
                                    You're ready to begin
                                </strong>

                                <span>
                                    Language selected:
                                    {' '}
                                    {language === 'hi'
                                        ? 'Hindi'
                                        : 'English'}
                                </span>
                            </div>

                            {instruction.length > 0 && (

                                <Link
                                    to={{
                                        pathname: '/edashboard',
                                        state: {
                                            exam_id: exam_id1,
                                            test_id: test_id,
                                            regid: regid,
                                            email: email,
                                            topic_name:
                                                instruction[0].topic_name
                                        }
                                    }}
                                    className="instruction-start-button"
                                >
                                    <span>
                                        Start Test Now
                                    </span>

                                    <FaChevronRight />
                                </Link>

                            )}

                        </div>

                    )}

                </div>

            </div>
        );
    }
}

export default HOC(Instruction);